<template>
  <div>
    <vs-popup :active.sync="isNotePopupOpen" title="Not Ekle">
      <div class="p-4">
        <vs-textarea v-model="tempNote" label="Notunuzu giriniz" rows="3"/>
        <div class="flex justify-end mt-4">
          <vs-button @click="saveNote" class="mr-2">Kaydet</vs-button>
          <vs-button color="danger" @click="isNotePopupOpen = false">İptal</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Ad Ekle Popup -->
    <vs-popup :active.sync="isNamePopupOpen" title="Ad Ekle" :class="{'kiosk-popup-no-close': isKiosk}">
      <div class="p-4">
        <vs-input ref="customerNameInput" v-model="tempCustomerName" label="Adınızı giriniz" class="w-full"/>
        <div class="flex justify-end mt-4">
          <vs-button @click="saveCustomerName" class="mr-2">Kaydet</vs-button>
          <vs-button v-if="!isKiosk" color="danger" @click="isNamePopupOpen = false">İptal</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Ürün Birleştir Modal -->
    <vs-popup id="mergeProductModal" :active.sync="isMergeModalOpen" title="Ürün Birleştir">
      <vs-row vs-type="flex" vs-w="12" vs-justify="center">
        <!-- Başlık ve Mevcut Tutar -->
        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">
          <div
            class="bg-white text-primary bold py-3 px-5"
            style="
              border-radius: 10px;
              border: 1px solid #e1e1e1;
              box-shadow: 0px 3px 6px #00000029;
              font-size: 1.2rem;
            "
          >
            Yeni Birleşik Ürün Fiyatı Giriniz
          </div>
        </vs-col>

        <!-- Mevcut Toplam -->
        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">
          <div
            class="bg-secondary text-primary bold py-2 px-4"
            style="
              border-radius: 10px;
              border: 1px solid #e1e1e1;
              font-size: 1rem;
            "
          >
            Mevcut Toplam: {{ $toCurrency(selectedGroupsPrice) }}
          </div>
        </vs-col>

        <!-- Ödenen Tutar (varsa) -->
        <vs-col v-if="totalPayedPriceForMerge > 0" vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">
          <div
            class="bg-warning text-white bold py-2 px-4"
            style="
              border-radius: 10px;
              border: 1px solid #e1e1e1;
              font-size: 1rem;
            "
          >
            Ödenen Tutar: {{ $toCurrency(totalPayedPriceForMerge) }}
          </div>
        </vs-col>

        <!-- Fiyat Input -->
        <vs-col vs-type="flex" vs-w="8" vs-justify="center" class="mb-4">
          <input
            autofocus="true"
            id="txtMergePrice"
            ref="txtMergePrice"
            name="mergePrice"
            autocomplete="off"
            size="large"
            type="text"
            v-model="newMergePrice"
            class="bold w-full price-input"
            placeholder="0.00"
          />
        </vs-col>

        <!-- Sanal Klavye -->
        <vs-col vs-type="flex" vs-w="10" vs-justify="center">
          <vs-row vs-type="flex" vs-w="12">
            <!-- Sayılar 1-9 -->
            <vs-col
              vs-type="flex"
              vs-w="4"
              v-for="number in numbers"
              :key="number"
              class="my-1 px-1"
            >
              <vs-button
                color="transparent"
                @click="appendToPrice(number)"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;"
              >
                {{ number }}
              </vs-button>
            </vs-col>

            <!-- Alt satır: 0, ., Sil -->
            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">
              <vs-button
                @click="appendToPrice('0')"
                color="transparent"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;"
              >
                0
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">
              <vs-button
                @click="appendToPrice('.')"
                color="transparent"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;"
              >
                .
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="4" class="my-1 px-1">
              <vs-button
                color="transparent"
                @click="clearPrice"
                class="bg-secondary w-full text-primary bold half-friendly-border py-4"
                style="font-size: 1.5rem; min-height: 60px;"
              >
                Sil
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-col>

        <!-- Onayla ve İptal Butonları -->
        <vs-col vs-type="flex" vs-w="8" vs-justify="center" class="mt-4">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="flex" vs-w="6" class="pr-2">
              <vs-button
                @click="confirmMergeFromModal"
                :disabled="!newMergePrice || parseFloat(newMergePrice) <= 0 || parseFloat(newMergePrice) < totalPayedPriceForMerge"
                color="transparent"
                class="bg-success text-white w-full bold py-4"
                style="font-size: 1.3rem; min-height: 55px;"
              >
                Onayla
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="pl-2">
              <vs-button
                @click="cancelMerge"
                color="transparent"
                class="bg-danger text-white w-full bold py-4"
                style="font-size: 1.3rem; min-height: 55px;"
              >
                İptal
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>
    <custom-loading-component />
    <qr-reader
      ref="qrReader"
      @reduceSuccess="commitPay"
      @success="commitQrCode"
    />
    <vs-row vs-type="block" vs-w="12">
      <vs-popup
        fullscreen
        :active.sync="isActive"
        id="orderList"
        @update:active="handlePopupUpdate"
      >
        <calc
          v-if="isPosEnabled"
          ref="calculatorPage"
          @closeEvent="closeCalculatorPage"
          @doPay="doPay"
          @setIsPieced="setIsPieced"
          @open-discount="isActiveDiscount = true"
          :totalPrice="separatePaymentPrice"
          :currentDate="currentDate"
          :currentTime="currentTime"
        />
        <calc
          v-if="!isPosEnabled"
          ref="calculatorPage"
          @closeEvent="closeCalculatorPage"
          @doPay="doPayWithoutPos"
          @open-discount="isActiveDiscount = true"
          :totalPrice="separatePaymentPrice"
          :currentDate="currentDate"
          :currentTime="currentTime"
        />
        <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
          <vs-button
            size="large"
            color="transparent"
            class="payment-label bg-primary2 text-white w-full"
            icon-pack="feather"
            icon="icon-credit-card"
          >
            Ödeme Ekranı
          </vs-button>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-w="12"
          class="info-row px-3"
          vs-justify="space between"
          v-if="activePersonel && !isKiosk"
        >
          <vs-col
            vs-w="6"
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
          >
            <p class="text-primary bold">Personel Adı :</p>
            <p class="text-primary ml-2 weight-500">
              {{ activePersonel ? activePersonel.name : "" }}
            </p>
          </vs-col>
          <vs-col
            vs-w="6"
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="center"
          >
            <p class="text-primary weight-600 mr-3">{{ currentDate }}</p>
            <p class="text-primary weight-500">{{ currentTime }}</p>
          </vs-col>
        </vs-row>
        <div id="data-list-thumb-view" class="data-list-container">
          <vs-table
            :multiple="!isKiosk"
            :data="sortedPaymentGroups"
            v-model="selectedPaymentGroup"
            id="orderListTable"
            :class="getTableClass"
          >
            <div
              slot="header"
              class="w-full flex flex-wrap items-center flex-grow justify-between"
            ></div>
            <template slot="thead">
              <vs-th class="w-6/12" style="justify-content: flex-start !important;">
                <p class="column-head-text text-left">Ürün</p>
              </vs-th>
              <vs-th class="w-3/12">
                <p class="column-head-text">Ekstra</p>
              </vs-th>
              <vs-th class="w-3/12">
                <p class="column-head-text">Fiyat</p>
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                v-for="(tr, indextr) in data"
                :data="tr"
                :key="indextr"
                style="height: 5rem"
                :class="{ 'bg-secondary2': indextr % 2 != 0 }"
              >
                <vs-td class="w-6/12">
                  <vs-row
                    vs-type="block"
                    vs-w="12"
                    v-for="entry in tr.entries"
                    :key="entry.id"
                  >
                    <p class="text-left tr-text text-primary">
                      {{
                        entry.productName +
                        (entry.quantity > 1 ? " - x" + entry.quantity : "")
                      }}
                    </p>
                    <div v-if="(entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.Recipe.recipeSteps || entry.Recipe.RecipeSteps)) || (entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps)">
                      <p
                        v-for="(rawmaterial, rawMaterialIndex) in (entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.recipe.recipeSteps || entry.Recipe.RecipeSteps)) || entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps || []"
                        v-if="rawmaterial && (rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed || (rawmaterial.selected && !rawmaterial.isDefault) || (rawmaterial.Selected && !rawmaterial.IsDefault) || (rawmaterial.isSelected && !rawmaterial.isDefault) || (rawmaterial.selected && !rawmaterial.IsDefault) || (rawmaterial.Selected && !rawmaterial.isDefault) || rawmaterial.isRemoved === true || rawmaterial.IsRemoved === true || rawmaterial.is_removed === true || (rawmaterial.selected === true && rawmaterial.isDefault === false))"
                        :key="rawMaterialIndex"
                        :class="{'line-through': rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed}"
                        class="text-left tr-text-child text-primary"
                      >
                         {{ (rawmaterial.name || rawmaterial.Name || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.name) || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.Name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.Name) || '').trim() }}
                      </p>
                    </div>
                  </vs-row>
                </vs-td>
                <vs-td class="w-4/12">
                  <vs-row
                    vs-type="block"
                    vs-w="12"
                    v-for="entry in tr.entries"
                    :key="entry.rowId"
                  >
                    <span
                      class="tr-text-child text-center text-primary"
                      v-for="extra in entry.extras"
                      :key="extra.id"
                    >
                      <p
                        class="product-extra text-primary"
                        v-if="extra.quantity > 0 && extra.variants.length == 0"
                      >
                        x{{ extra.quantity }} / {{ extra.name }}
                      </p>
                      <p
                        style="display: block"
                        class="product-extra text-primary"
                        v-else-if="extra.variants.length > 0"
                        v-for="seletedVariantExtra in returnSelectedExtraVariant(
                          extra
                        )"
                        :key="seletedVariantExtra"
                      >
                        {{ seletedVariantExtra }}
                      </p>
                    </span>
                  </vs-row>
                </vs-td>
                <vs-td class="w-1/12">
                  <vx-tooltip
                    v-if="
                      tr.entries.some(
                        (x) => x.originPrice != x.price && x.originPrice
                      )
                    "
                    :text="getTotalGift(tr) + 'İndirim'"
                    position="top"
                  >
                    <feather-icon
                      icon="GiftIcon"
                      svgClasses="h-5 w-5"
                      class="text-success"
                    />
                  </vx-tooltip>
                  <span
                    v-if="tr.payedPrice > 0 && tr.payedPrice != tr.totalPrice"
                    class="text-center text-primary tr-text w-full line-through"
                  >
                    {{ $toCurrency(tr.totalPrice) }}
                  </span>
                  <p
                    class="text-center text-primary tr-text w-full"
                    :class="{ 'payed-row': $isRowPaid(tr) }"
                  >
                    {{
                      !$isRowPaid(tr)
                        ? $toCurrency(tr.totalPrice - tr.payedPrice)
                        : "Ödendi"
                    }}
                    ₺
                  </p>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <!-- Kiosk Sipariş Notu Gösterimi (Eski layout, yeni füme renk) -->
          <vs-row v-if="false && isKiosk && note" vs-type="flex" vs-w="12" class="px-5 py-2 kiosk-info-row-gray">
              <vs-col vs-w="12" vs-type="flex" vs-align="center">
                  <feather-icon icon="MessageSquareIcon" class="kiosk-gray-icon mr-2" />
                  <p class="kiosk-gray-label mr-2">Not:</p>
                  <p class="kiosk-gray-value flex-grow">{{ note }}</p>
                  <vs-button size="small" color="danger" type="filled" icon="icon-trash-2" icon-pack="feather" @click="clearNote" class="ml-3 kiosk-delete-btn">Sil</vs-button>
              </vs-col>
          </vs-row>

          <!-- Kiosk Ad Gösterimi (Eski layout, yeni füme renk) -->
          <vs-row v-if="isKiosk && customerName" vs-type="flex" vs-w="12" class="px-5 py-2 kiosk-info-row-gray" style="position: relative;">
              <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
                  <feather-icon icon="UserIcon" class="kiosk-gray-icon mr-2" />
                  <p class="kiosk-gray-label mr-2">Ad:</p>
                  <p class="kiosk-gray-value">{{ customerName }}</p>
                  <vs-button size="small" color="danger" type="filled" icon="icon-trash-2" icon-pack="feather" @click="clearCustomerName" class="ml-3 kiosk-delete-btn" style="position: absolute; right: 20px;">Sil</vs-button>
              </vs-col>
          </vs-row>

          <vs-row
            vs-type="flex"
            vs-w="12"
            class="px-5 res-footer-row"
            style="background:#FFD1D1 !important;"
          >
            <vs-col vs-type="flex" :vs-w="isKiosk ? 4 : 4" vs-justify="flex-start" class="res-footer-col">
              <div class="w-auto flex align-center">
                <div class="d-flex align-center pointer">
                  <p class="price-label bold mr-3" :class="{'text-2xl': isKiosk}">Toplam Tutar:</p>
                  <p class="price bold mr-3" :class="{'text-4xl': isKiosk}">
                    {{ $toCurrency(totalPrice) }}
                  </p>
                  <vs-button
                    v-show="orderPayments != null && orderPayments.length > 0"
                    @blur="showPaymentHistory = false"
                    @click="showPaymentHistory = !showPaymentHistory"
                    icon-pack="feather"
                    icon="icon-more-horizontal"
                    radius
                    size="small"
                    color="transparent"
                    class="sale-box-shadow bg-secondary text-primary"
                  />
                </div>
              </div>
            </vs-col>
            
            <!-- Kiosk Modunda Ortadaki Ad Ekle Sütunu -->
            <vs-col vs-type="flex" vs-w="4" vs-justify="center" vs-align="center" class="res-footer-col" v-if="isKiosk">
               <div class="d-flex" style="gap: 8px;">
                  <vs-button @click="openNamePopup"
                    class="sale-text-shadow bg-primary2 sale-box-shadow text-light quantity-label half-friendly-border px-6"
                    color="transparent" style="height:3.5rem!important; font-size: 1.2rem;">
                   Ad Ekle <span style="margin-left: 4px;">*</span>
                 </vs-button>
               </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="1" vs-xs="3" vs-align="center" class="res-footer-col res-order-3" v-if="!isKiosk">
              <vs-button @click="openNotePopup"
                   class="sale-text-shadow bg-primary2 sale-box-shadow text-light quantity-label half-friendly-border"
                   color="transparent" style="height:2.5rem!important;">
                Not
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" :vs-w="isKiosk ? 0 : 3" vs-xs="9" vs-justify="center" vs-align="center" class="res-footer-col res-order-4" v-if="!isKiosk">
              <vs-checkbox class="bold text-primary mr-2" v-model="isPrintOrders">Fiş Yazdırılsın</vs-checkbox>
              <div v-if="isPrintOrders" class="d-flex align-center ml-2" style="border: 1px solid #6A1F13; border-radius: 5px; padding: 2px 5px; background: white;">
                <span class="text-primary bold mr-2" style="font-size: 0.8rem;">Kopya:</span>
                <input type="number" v-model.number="printCopyCount" min="1" max="10" 
                       style="width: 40px; border: none; font-weight: bold; color: #6A1F13; text-align: center; outline: none;">
              </div>
            </vs-col>
            <vs-col vs-type="flex" :vs-w="isKiosk ? 4 : 4" :vs-justify="isKiosk ? 'center' : 'flex-end'" vs-align="center" class="res-footer-col">
              <div v-if="isKiosk" class="d-flex" style="gap: 8px;">
                 <!-- Ortadaki sütuna alındı -->
              </div>
              <div class="flex justify-flex-end align-center" style="width: 100%; justify-content: flex-end;" v-else>
                <p class="price-label bold mr-5">Seçilen Tutar:</p>
                <p class="price bold">
                  {{ $toCurrency(selectedGroupsPrice) }}
                </p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="block" vs-w="2">
              <transition name="fade">
                <div
                  v-show="showPaymentHistory && orderPayments.length > 0"
                  class="payment-history w-full text-primary"
                >
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row
                      class="payment-log bold"
                      vs-type="flex"
                      vs-w="12"
                      vs-justify="center"
                      v-for="log in orderPayments"
                      :key="log.id"
                    >
                      {{ $toCurrency(log.price) }} {{ log.paymentMethod.name }}
                    </vs-row>
                  </vs-row>
                </div>
              </transition>
            </vs-col>
            <vs-col vs-type="block" vs-w="8">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  class="m-0 align-center"
                >
                  <p v-if="isKiosk" class="text-2xl bold text-primary mr-4">Ödeme Şekli:</p>
                  <select-payment-type
                    ref="selectPaymentType"
                    :dontCloseCalc="false"
                    :isKiosk="isKiosk"
                    :totalPrice="totalPrice"
                    :currentDate="currentDate"
                    :currentTime="currentTime"
                    @open-discount="isActiveDiscount = true"
                  />
                </vs-row>
                <vs-row v-if="selectedPaymentGroup.length > 1 && !isKiosk" vs-type="flex" vs-w="12" vs-justify="center" class="mt-3">
                   <vs-button @click="mergeSelectedProducts"
                        color="transparent" class="text-white bg-warning bold sale-box-shadow"
                        style="height: 48px; font-size: 1rem;" icon-pack="feather" icon="icon-layers">
                        Ürün Birleştir
                    </vs-button>
                </vs-row>
                <vs-row v-if="isPosEnabled && isPosConnectionError" vs-type="flex" vs-justify="center" class="mb-2 mt-4 w-full">
                  <div class="w-full text-center py-2 px-4 bg-danger text-white bold half-friendly-border" style="border-radius: 8px; box-shadow: 0px 3px 6px rgba(0,0,0,0.16);">
                    <i class="feather icon-wifi-off mr-2"></i>
                    POS Bridge Bağlantısı Koptu! Lütfen Servisi Kontrol Edin.
                  </div>
                </vs-row>

                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  class="m-0"
                >
                  <vs-col
                    vs-type="flex"
                    :vs-w="isKiosk ? 5 : 3"
                    vs-justify="flex-end"
                    class="mr-2"
                  >
                    <vs-button
                      @click="isActive = false"
                      :disabled="isLoading"
                      size="large"
                      color="transparent"
                      class="bold sale-box-shadow"
                      :class="isKiosk ? 'kiosk-btn-large bg-primary-gradient text-white' : 'half-friendly-border w-64 bg-primary text-white'"
                      icon-pack="feather"
                      icon="icon-arrow-left"
                    >
                      Geri Dön
                    </vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    :vs-w="isKiosk ? 5 : 3"
                    vs-justify="flex-start"
                    class="ml-2 mr-2"
                  >
                    <vs-button
                      v-if="!isCommitable && isPosEnabled"
                      :disabled="isTransaction || (isPosConnectionError && selectedPaymentMethod && (selectedPaymentMethod.id == VUE_APP_CASH_PAYMENT_ID || selectedPaymentMethod.id == VUE_APP_CREDIT_PAYMENT_ID))"
                      color="transparent"
                      class="text-white bold sale-box-shadow"
                      :class="isKiosk ? 'kiosk-btn-large bg-success-gradient' : 'bg-success p-1 w-64 text-medium-small'"
                      @click="
                        doPay(
                          selectedPaymentGroup.length > 0
                            ? selectedGroupsPrice
                            : totalPrice,
                          false
                        )
                      "
                    >
                      {{
                        selectedPaymentMethod
                          ? selectedPaymentMethod.name
                          : null
                      }}
                      ile Öde
                      {{
                        selectedPaymentGroup.length > 0
                          ? $toCurrency(selectedGroupsPrice)
                          : $toCurrency(totalPrice)
                      }}
                    </vs-button>
                    <vs-button
                      v-if="!isCommitable && !isPosEnabled"
                      :disabled="isTransaction"
                      color="transparent"
                      class="text-white bold sale-box-shadow"
                      :class="isKiosk ? 'kiosk-btn-large bg-success-gradient' : 'bg-success p-1 w-64 text-medium-small'"
                      @click="
                        doPayWithoutPos(
                          selectedPaymentGroup.length > 0
                            ? selectedGroupsPrice
                            : totalPrice,
                          false
                        )
                      "
                    >
                      {{
                        selectedPaymentMethod
                          ? selectedPaymentMethod.name
                          : null
                      }}
                      ile Öde
                      {{
                        selectedPaymentGroup.length > 0
                          ? $toCurrency(selectedGroupsPrice)
                          : $toCurrency(totalPrice)
                      }}
                    </vs-button>
                    <transition name="slide-fade">
                      <vs-button
                        :disabled="isTransaction"
                        v-if="isCommitable"
                        size="large"
                        color="transparent"
                        @click="createCommitModel"
                        class="glowing text-white bg-success3 bold sale-box-shadow"
                        :class="isKiosk ? 'kiosk-btn-large' : 'w-64'"
                      >
                        Sepeti Bitir
                      </vs-button>
                    </transition>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-w="2"
              vs-justify="flex-end"
              vs-align="center"
            >
              <div
                v-if="!isKiosk"
                class="bg-secondary calc-button sale-box-shadow"
                @click.stop="totalPrice != 0 ? seperatePayment() : null"
              >
                <vs-button
                  :disabled="totalPrice == 0"
                  color="transparent"
                  type="flat"
                  class="small-icon text-primary p-0"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                />
                <vs-button
                  :disabled="totalPrice == 0"
                  color="transparent"
                  type="flat"
                  class="large-icon text-primary p-0"
                  icon-pack="feather"
                  icon="icon-percent"
                />
              </div>
            </vs-col>
          </vs-row>
        </div>
        <printer2
          ref="printer2"
          :isKiosk="isKiosk"
          :totalPrice="totalPrice"
          :totalDiscountPrice="totalDiscountPrice"
          :orderEntries="cloneCurrentCart.cartEntries"
          :currentDateTime="currentDate + ' ' + currentTime"
          :activePersonal="activePersonel ? activePersonel.name : ''"
          :branchName="activePersonel ? (activePersonel.branch ? activePersonel.branch.name : activePersonel.userBranch) : ''"
          :note="note"
          :customerName="customerName"
          :printCopyCount="printCopyCount"
        />
        <discount
          ref="discount"
          @appendDiscount="appendDiscount"
          :priceToDiscount="
            selectedPaymentGroup.length > 0 ? selectedGroupsPrice : totalPrice
          "
          :currentDate="currentDate"
          :currentTime="currentTime"
        />
      </vs-popup>
    </vs-row>
    <cari-select ref="cariSelect" @cari-selected="handleCariSelected" />
  </div>
</template>

<script>
import Discount from "./Discount";
import Calc from "./Calc.vue";
import CustomLoadingComponent from "@/views/pages/customLoadingComponent";
import QrReader from "./QrReader.vue";
import { uuid } from "vue-uuid";
import { completePayment, addDiscountLog } from "@/api/SelfService";
import SelectPaymentType from "./SelectPaymentType.vue";
import { FindAvailableCampaigns } from "@/api/Campaign.js";
import { getPosSettings } from "@/api/AppSettings";
import Printer2 from "./Printer2.vue";
import CariSelect from "../SelfService/CariSelect.vue";

export default {
  props: {
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomLoadingComponent,
    Calc,
    SelectPaymentType,
    Printer2,
    Discount,
    QrReader,
    CariSelect,
  },
  data() {
    return {
      cloneCurrentCart: [],
      selectedGift: null,
      isPosEnabled: false,
      isPrintOrders: true,
      orderBillEntries: [],
      isTransaction: false,
      showPaymentHistory: false,
      isCommitable: false,
      isPaymentStarted: false,
      selectedPaymentGroup: [],
      isActive: false,
      orderPayments: [],
      paymentGroups: [],
      separatePaymentPrice: 0,
      paymentDiscount: {},
      selectedCari: null,
      discounts: [],
      ids: [],
      isPieced: false,
      posType: 0,
      note: "",
      customerName: "",
      tempNote: "",
      tempCustomerName: "",
      isNotePopupOpen: false,
      isNamePopupOpen: false,
      // Merge modal data
      isMergeModalOpen: false,
      newMergePrice: "",
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      selectedGroupsForMerge: [],
      totalPayedPriceForMerge: 0,
      printCopyCount: 1,
      isPosConnectionError: false,
      posConnectionInterval: null,
      VUE_APP_CASH_PAYMENT_ID: parseInt(process.env.VUE_APP_CASH_PAYMENT_ID),
      VUE_APP_CREDIT_PAYMENT_ID: parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID)
    };
  },
  watch: {
    isNamePopupOpen(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.customerNameInput) {
              const inputEl = this.$refs.customerNameInput.$el.querySelector('input');
              if (inputEl) {
                inputEl.focus();
                inputEl.select();
              } else {
                this.$refs.customerNameInput.focus();
              }
            }
          }, 150);
        });
      } else {
        if (this.isKiosk && !this.customerName) {
          this.$nextTick(() => {
            this.isNamePopupOpen = true;
          });
        }
      }
    },
    selectedPaymentGroup(newVal, oldVal) {
      if (!Array.isArray(newVal)) {
        this.selectedPaymentGroup = Array.isArray(oldVal) ? oldVal : [];
        return;
      }
      if (newVal.length > 0) {
        let lastItem = newVal[newVal.length - 1];
        if (lastItem && lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = Array.isArray(oldVal) ? oldVal : [];
        }
      }
    },
    isActive: function (val) {
      if (val) {
        this.checkPosDevice().then(() => {
          this.startPosConnectionTimer();
        });
        this.isPaymentStarted = false;
        this.isTransaction = false;
        this.initValues();
        this.initGifts();

        const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
          const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
          const creditCardMethod = sessionPaymentMethods.find(m => m.id == creditId);
          if (creditCardMethod) {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
          } else {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
          }
        }
        if (this.isKiosk) {
            if (!this.customerName) {
                this.openNamePopup();
            }
        }
        this.broadcastCartState();
      } else {
        this.stopPosConnectionTimer();
        this.isPosConnectionError = false;
        this.isPaymentStarted = false;
        this.isTransaction = false;
        this.cloneCurrentCart = [];
        this.selectedPaymentGroup = [];
        this.orderPayments = [];
        this.selectedCari = null;
        this.discounts = [];
        // NOT ve AD sıfırlanmıyor - kullanıcı geri döndüğünde korunur
        // Sadece ödeme tamamlandığında (createCommitModel) sıfırlanır
        this.cloneCurrentCart = { cartEntries: [] };
        this.broadcastCartState([]);
      }
    },
    totalPrice: function (val) {
      if (val == 0 && this.isActive == true) {
        this.isCommitable = true;
        this.createCommitModel();
      } else {
        this.isCommitable = false;
      }
    },
    selectedPaymentMethod(val) {
      if (val.id == 4) this.isActiveDiscount = true;
    },
    isPrintOrders(val) {
      localStorage.setItem("selfservice2_isPrintOrders", val);
    },
    printCopyCount(val) {
      localStorage.setItem("selfservice2_printCopyCount", val);
    },
    note(val) {
      if (this.isKiosk) localStorage.setItem("kiosk_note", val);
    },
    customerName(val) {
      if (this.isKiosk) {
        localStorage.setItem("kiosk_customerName", val);
        if (!val && this.isActive) {
          this.openNamePopup();
        }
      }
    },
    isReset(val) {
      if (val) {
        this.note = "";
        this.customerName = "";
        this.tempNote = "";
        this.tempCustomerName = "";
        
        if (this.isKiosk) {
          localStorage.removeItem("kiosk_note");
          localStorage.removeItem("kiosk_customerName");
        }

        // Ödeme ekranı açıksa kapat ve state'i temizle
        if (this.isActive) {
          this.isActive = false;
          this.isPaymentStarted = false;
          this.isTransaction = false;
          this.selectedPaymentGroup = [];
          this.paymentGroups = [];
          this.orderPayments = [];
          this.discounts = [];
          this.cloneCurrentCart = { cartEntries: [] };
        }

        // Reset tetiklendikten sonra store'u tekrar false'a çek (Bir sonraki reset için hazır olsun)
        this.$nextTick(() => {
          this.isReset = false;
        });
      }
    },
    discounts: {
      deep: true,
      handler(newDiscounts) {
        this.broadcastCartState(newDiscounts);
      }
    }
  },
  computed: {
    getTableClass() {
      let classes = [];
      if (this.isKiosk) {
        classes.push('kiosk-table');
        if (this.note) classes.push('has-note');
        if (this.customerName) classes.push('has-name');
      }
      return classes.join(' ');
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      },
    },
    totalDiscountPrice() {
      // Ödeme bazlı indirimler
      let paymentDiscounts = 0;
      if (this.orderPayments && this.orderPayments.length > 0) {
        paymentDiscounts = this.orderPayments.reduce(function (total, num) {
          // v110: İndirim (4) ve Kampanya (15) tutarlarını indirim toplamına dahil et
          if (num.paymentMethod && (num.paymentMethod.id == 4 || num.paymentMethod.id == 15))
            return total + (parseFloat(num.price) || 0);
          else return total + 0;
        }, 0);
      }

      // Ürün bazlı (kampanya) indirimler
      let campaignDiscounts = 0;
      const targetEntries = (this.cloneCurrentCart && this.cloneCurrentCart.cartEntries) 
        ? this.cloneCurrentCart.cartEntries 
        : (this.paymentGroups && this.paymentGroups.length > 0 ? this.paymentGroups.flatMap(p => p.entries) : []);

      if (targetEntries && targetEntries.length > 0) {
        // v111.1: Sadece gerçekten indirim uygulanmış (originPrice > price) kalemleri ve 
        // masada en az bir indirim/kampanya ödemesi varsa bu farkı yansıt.
        const hasAnyDiscountPayment = this.orderPayments && this.orderPayments.some(p => p.paymentMethod && (p.paymentMethod.id == 4 || p.paymentMethod.id == 15));
        
        campaignDiscounts = targetEntries.reduce((total, entry) => {
          let origin = parseFloat(entry.originPrice) || 0;
          let current = parseFloat(entry.price) || 0;
          
          // Eğer originPrice set edilmemişse veya price ile aynıysa indirim yoktur.
          if (origin <= current) return total;
          
          let diff = origin - current;
          return total + diff;
        }, 0);
      }
      
      return Math.round((paymentDiscounts + campaignDiscounts) * 100) / 100;
    },

    totalPaidAmount() {
      if (!this.orderPayments) return 0;
      return this.orderPayments.reduce((total, num) => {
        // v111: İndirim (4) ve Kampanya (15) dışındaki gerçek ödemeleri topla
        if (num.paymentMethod && (num.paymentMethod.id == 4 || num.paymentMethod.id == 15)) {
          return total;
        }
        return total + (parseFloat(num.price) || 0);
      }, 0);
    },
    isActiveDiscount: {
      get() {
        return this.$refs.discount.isActive;
      },
      set(val) {
        this.$refs.discount.isActive = val;
      },
    },
    selectedPaymentMethod: {
      get() {
        return this.$store.getters["selfservice/getSelectedPaymentMethod"];
      },
      set(val) {
        if (val)
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
      },
    },
    paymentMethods: function () {
      return this.$store.getters["selfservice/getPaymentMethods"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    totalOriginPrice: function () {
      return this.calculateTotalOriginPrice(this.paymentGroups);
    },
    totalPrice: function () {
      return this.calculateSelectedRemainingPrice(this.paymentGroups);
    },
    selectedGroupsPrice: function () {
      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
    },
    currentCart: {
      get() {
        return this.$store.getters["selfservice/getCurrentCart"];
      },
      set(payload) {
        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);
      },
    },
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },

    sortedPaymentGroups() {
      if (!this.paymentGroups) return [];
      return [...this.paymentGroups].sort((a, b) => {
        // createdDate üzerinden sırala (en yeni en üstte)
        const dateA = (a.entries && a.entries[0] && a.entries[0].createdDate) ? new Date(a.entries[0].createdDate) : null;
        const dateB = (b.entries && b.entries[0] && b.entries[0].createdDate) ? new Date(b.entries[0].createdDate) : null;

        if (dateA && dateB) {
          return dateB - dateA;
        }

        // Tarih yoksa rowIndex (ID) üzerinden dene
        return b.rowIndex - a.rowIndex;
      });
    },
    toggleCalc: {
      get() {
        return this.$refs.calculatorPage.isActive;
      },
      set(val) {
        this.$refs.calculatorPage.isActive = val;
      },
    },
  },

  methods: {
    openNotePopup() {
      this.tempNote = this.note;
      this.isNotePopupOpen = true;
    },
    saveNote() {
      this.note = this.tempNote;
      this.isNotePopupOpen = false;
    },
    clearNote() {
      this.note = "";
      this.tempNote = "";
    },
    openNamePopup() {
      this.tempCustomerName = this.customerName;
      this.isNamePopupOpen = true;
    },
    saveCustomerName() {
      const name = this.tempCustomerName ? this.tempCustomerName.trim() : "";
      if (this.isKiosk) {
        if (!name || name.length < 2) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Lütfen geçerli bir isim giriniz (en az 2 karakter).",
          });
          return;
        }
      }
      this.customerName = name;
      this.isNamePopupOpen = false;
    },
    clearCustomerName() {
      this.customerName = "";
      this.tempCustomerName = "";
    },
    mergeSelectedProducts() {
      if (this.selectedPaymentGroup.length <= 1) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Birleştirilecek en az 2 ürün seçmelisiniz.",
        });
        return;
      }

      // Seçilen grupları sakla ve ödenen tutarı hesapla
      this.selectedGroupsForMerge = [...this.selectedPaymentGroup];
      this.totalPayedPriceForMerge = 0;
      this.selectedGroupsForMerge.forEach((group) => {
        this.totalPayedPriceForMerge += group.payedPrice || 0;
      });

      // Modal aç ve input temizle
      this.newMergePrice = "";
      this.isMergeModalOpen = true;

      // Input'a focus ver
      this.$nextTick(() => {
        if (this.$refs.txtMergePrice) {
          this.$refs.txtMergePrice.focus();
        }
      });
    },
    appendToPrice(value) {
      // Eğer nokta ekleniyor ve zaten nokta varsa, ekleme
      if (value === '.' && this.newMergePrice.includes('.')) {
        return;
      }

      // Nokta sonrası en fazla 2 basamak
      if (this.newMergePrice.includes('.')) {
        const decimalPart = this.newMergePrice.split('.')[1];
        if (decimalPart && decimalPart.length >= 2 && value !== '.') {
          return;
        }
      }

      this.newMergePrice += value;
    },
    clearPrice() {
      if (this.newMergePrice.length > 0) {
        this.newMergePrice = this.newMergePrice.slice(0, -1);
      }
    },
    confirmMergeFromModal() {
      const newPrice = parseFloat(this.newMergePrice);

      if (!newPrice || newPrice <= 0) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Geçerli bir fiyat giriniz.",
        });
        return;
      }

      if (newPrice < this.totalPayedPriceForMerge) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: `Yeni fiyat en az ${this.$toCurrency(this.totalPayedPriceForMerge)} olmalıdır (ödenen tutar).`,
        });
        return;
      }

      // Modal kapat
      this.isMergeModalOpen = false;
      this.newMergePrice = "";

      // Birleştirme işlemini yap
      this.confirmMerge(newPrice);
    },
    cancelMerge() {
      this.isMergeModalOpen = false;
      this.newMergePrice = "";
      this.selectedGroupsForMerge = [];
      this.totalPayedPriceForMerge = 0;
    },
    confirmMerge(newPrice) {
      // Seçilen grupların verilerini hesapla
      let totalOriginalPrice = 0;
      let totalPayedPrice = 0;
      this.selectedGroupsForMerge.forEach((group) => {
        totalOriginalPrice += group.totalPrice || 0;
        totalPayedPrice += group.payedPrice || 0;
      });

      // Fiyat farkını hesapla
      const priceDifference = totalOriginalPrice - newPrice;

      // Yeni birleştirilmiş grup oluştur
      let mergedGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: newPrice,
        payedPrice: totalPayedPrice,
        status: "Kalan",
      };

      // Tüm entry'leri birleştir
      this.selectedGroupsForMerge.forEach((group) => {
        mergedGroup.entries = mergedGroup.entries.concat(group.entries);
      });

      // Entry fiyatlarını ayarla (ilk entry'ye tüm fiyat, diğerleri 0)
      if (mergedGroup.entries.length > 0) {
        mergedGroup.entries[0].price = newPrice;
        for (let i = 1; i < mergedGroup.entries.length; i++) {
          mergedGroup.entries[i].price = 0;
        }
      }

      // Seçilen grupları kaldır ve yeni grubu ekle
      let remainingGroups = this.paymentGroups.filter((group) =>
        !this.selectedGroupsForMerge.some((selected) => selected.rowIndex === group.rowIndex)
      );
      remainingGroups.push(mergedGroup);
      this.paymentGroups = remainingGroups;

      // Eğer fiyat indirimi varsa, Kampanya ödeme yöntemi olarak ekle
      if (priceDifference > 0) {
        let campaignPayment = {
          id: uuid.v1(),
          paymentMethod: {
            id: 15, // Kampanya payment method ID'si
            name: "Kampanya"
          },
          price: priceDifference,
          value: priceDifference,
          unit: "₺",
          description: "Ürün Birleştirme İndirimi",
          discountDescription: `${this.$toCurrency(totalOriginalPrice)} → ${this.$toCurrency(newPrice)}`,
        };
        this.orderPayments.push(campaignPayment);
      }

      // Seçimi temizle
      this.selectedPaymentGroup = [];
      this.selectedGroupsForMerge = [];
      this.totalPayedPriceForMerge = 0;

      // Fiyatları yeniden hesapla
      this.reCalculatePaymentGroup();

      this.$vs.notify({
        color: "success",
        title: "Başarılı",
        text: `Seçilen ürünler ${this.$toCurrency(newPrice)} fiyatı ile birleştirildi.`,
      });
    },
    commitQrCode(customer) {
      console.log(customer);
      console.log("çalıştı qr");
      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      console.log(this.cloneCurrentCart);
    },
    getTotalGift(row) {
      let totalGift = row.entries.reduce(function (total, num) {
        if (num.originPrice - num.price > 0)
          return total + (num.originPrice - num.price);
        else return total + 0;
      }, 0);
      return this.$toCurrency(totalGift);
    },
    initValues() {
      this.selectedGift = null;
      this.orderPayments = [];
      this.selectedCari = null;
      this.paymentGroups = [];
      this.selectedPaymentGroup = [];
      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      
      // v111.3 [SAFETY]: Adisyon (pro-forma) aşaması için de hammadde isimlerini kesinleştir
      if (this.cloneCurrentCart && this.cloneCurrentCart.cartEntries) {
          this.cloneCurrentCart.cartEntries.forEach(entry => {
              if (entry.recipe && entry.recipe.steps) {
                  entry.recipe.steps.forEach(step => {
                      if (step.isRemoved && (!step.name || step.name === "Malzeme")) {
                          step.name = (step.rawMaterial && (step.rawMaterial.name || step.rawMaterial.Name)) ? (step.rawMaterial.name || step.rawMaterial.Name) : 
                                     (step.productName ? step.productName : "Malzeme");
                      }
                  });
              }
          });
      }

      this.generatePaymentGroups();
      this.isTransaction = false;
      this.isPaymentStarted = false;
    },
    generatePaymentGroups() {
      this.paymentGroups.length = 0;
      this.cloneCurrentCart.cartEntries.forEach((entry) => {
        let tempPaymentGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: 0,
          status: "Kalan",
        };
        tempPaymentGroup.rowIndex = uuid.v1();
        tempPaymentGroup.entries.push(entry);
        tempPaymentGroup.totalPrice = entry.price;
        tempPaymentGroup.payedPrice = 0;
        tempPaymentGroup.status = "Kalan";

        this.paymentGroups.push(_.cloneDeep(tempPaymentGroup));
      });
      this.reCalculatePaymentGroup();
    },
    initGifts() {
      let productIds = [];
      let categoryIds = [];
      let totalPrice = 0;
      if (this.cloneCurrentCart.customer) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach((x) => {
          x.categoryId = x.categories[0].id;
        });
        let payments = this.orderPayments;
        let orderModel = {
          id: cart.id,
          customerId: cart.customer ? cart.customer.id : null,
          qrCode: cart.customer ? cart.customer.giftQrCode : null,
          totalPrice: cart.totalPrice,
          active: cart.active,
          cartEntries: [...cart.cartEntries],
          branchName: this.$currentUser.branch.name,
          paymentInformations: [...payments],
          userName: this.activePersonel.name,
          userId: this.activePersonel.id,
        };
        FindAvailableCampaigns(orderModel)
          .then((res) => {
            if (res && res.status == 200) {
              if (res.data.isValid) {
                this.cloneCurrentCart.cartEntries = res.data.newEntries;
                if (res.data.customerGiftId != null)
                  this.cloneCurrentCart.customerGiftId =
                    res.data.customerGiftId;
                else if (res.data.campaignGiftId != null)
                  this.cloneCurrentCart.campaignGiftId =
                    res.data.campaignGiftId;
                this.generatePaymentGroups();
              }
            } else {
              this.$fire({
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
              });
            }
          })
          .catch(() => {
            this.$fire({
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    appendDiscount(discountObj) {
      if (this.isTransaction) return;
      this.isTransaction = true;
      // 1. Log için ürünleri işlemden (temizlenmeden) ÖNCE belirle
      let logItems = [];
      if (this.selectedPaymentGroup && this.selectedPaymentGroup.length > 0) {
        logItems = this.selectedPaymentGroup.flatMap(r => r.entries);
      } else {
        // Eğer seçim yoksa (Toplam İndirim durumu), sepetin tamamındaki ürünleri al
        logItems = this.paymentGroups.flatMap(p => p.entries);
      }

      this.paymentDiscount = {
        paymentMethod: this.paymentMethods.find(x => x.id == 4) || this.selectedPaymentMethod,
        value: discountObj.value,
        description: discountObj.description,
        unit: discountObj.unit,
        selectedPaymentGroup: logItems.map(e => e.id),
        payedPrice: discountObj.payedPrice,
        discountDescription: discountObj.discountDescription,
        discountAmount: discountObj.priceToDiscount,
      };

      if (this.isPosEnabled) {
        this.doPay(discountObj.priceToDiscount, true);
      } else {
        this.doPayWithoutPos(discountObj.priceToDiscount, true);
      }

      this.discounts.push(this.paymentDiscount);
      this.paymentDiscount = {};

      // StaffActionLog for Discount
      try {
        if (logItems.length > 0) {
          addDiscountLog({
            tableId: 0,
            ids: logItems.map(e => e.id),
            totalDiscount: discountObj.priceToDiscount, // İndirim tutarını (örn: 40) gönder
            discountType: "Discount",
            actionType: "Discount",
            description: `${discountObj.description || ""} - ${discountObj.discountDescription || ""}`,
            items: logItems
          });
        }
      } catch (logErr) {
        console.error("StaffActionLog Discount error:", logErr);
      }
      this.isTransaction = false;
    },
    broadcastCartState(customDiscounts = null) {
      try {
        const discountsToSend = customDiscounts !== null ? customDiscounts : this.discounts;
        const broadcaster = new BroadcastChannel('cart-channel');
        broadcaster.postMessage({
          type: 'CART_UPDATE',
          data: {
            cartEntries: this.currentCart ? this.currentCart.cartEntries : [],
            discounts: discountsToSend
          }
        });
        broadcaster.close();
      } catch (err) {
        console.error("Error broadcasting cart state from OrderList:", err);
      }
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      let selectedVariants = extra.variants.filter((x) => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " / " + x.name);
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    createCommitModel() {
      // 1. Snapshot Verilerini Al (Masa sistemindeki gibi - Veriler temizlenmeden dondur)
      let cart = this.cloneCurrentCart;
      let snapshotTotalOriginPrice = 0;
      let snapshotTotalPrice = 0;
      let cartItemsForPrint = [];
      
      if (this.paymentGroups && this.paymentGroups.length > 0) {
        this.paymentGroups.forEach(group => {
           snapshotTotalPrice += (parseFloat(group.totalPrice) || 0);
           if (group.entries && group.entries.length > 0) {
             group.entries.forEach(entry => {
               if (entry) {
                 snapshotTotalOriginPrice += (parseFloat(entry.originPrice) || parseFloat(entry.price) || 0);
                 cartItemsForPrint.push(JSON.parse(JSON.stringify(entry)));
               }
             });
           }
        });
      }
      
      // v118.V36/V37/V38/V39: Kiosk modunda veya ödeme grupları boşsa sepetin tamamını yazdırılacaklar listesine al
      if (this.isKiosk || cartItemsForPrint.length === 0) {
          // cloneCurrentCart yerine direkt store'daki güncel sepeti (currentCart) kontrol et
          let targetCart = cart || this.currentCart;
          if (targetCart && targetCart.cartEntries && targetCart.cartEntries.length > 0) {
              cartItemsForPrint = JSON.parse(JSON.stringify(targetCart.cartEntries));
              if (snapshotTotalOriginPrice === 0) {
                  targetCart.cartEntries.forEach(e => {
                      snapshotTotalOriginPrice += (parseFloat(e.originPrice) || parseFloat(e.price) || 0);
                  });
              }
          }
      }
      
      const snapshotTotalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
      const snapshotActivePersonal = this.activePersonel ? (this.activePersonel.name + " " + (this.activePersonel.surname || "")) : "";
      const snapshotNote = this.note || "";
      const snapshotCustomerName = this.customerName || "";

      console.log("commit model çalıştı");
      if (this.isTransaction == true) {
        return;
      }
      this.isTransaction = true;
      let payments = [...this.orderPayments];

      // v107+: Termal Yazıcı İçin Veri Zenginleştirme (Snapshot'a enjekte et)
      if (cart) {
          cart.totalOriginPrice = parseFloat(this.totalOriginPrice) || 0;
          cart.totalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
          // v109/v111: Ödenen tutar olarak indirimleri içermeyen gerçek ödeme toplamını gönder
          cart.totalPayedPrice = parseFloat(this.totalPaidAmount) || 0;
          cart.isAdisyon = false; // Ödeme fişi olduğu için false
          
          if (cart.cartEntries) {
              cart.cartEntries.forEach(entry => {
                  if (!entry.originPrice) entry.originPrice = entry.price;
                  
                  // v111.6 [MAX-SAFETY]: Reçete adımlarında is_removed olanların ismini garantiye al (Tüm modelleri kapsar)
                  const targetRecipe = entry.recipe || entry.Recipe || entry.recipeSteps || entry.RecipeSteps;
                  if (targetRecipe && targetRecipe.steps) {
                      targetRecipe.steps.forEach(step => {
                          if (step.isRemoved) {
                              const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
                              const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
                              const safeName = (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) : 
                                             (pName ? pName : (step.name || step.Name || "Malzeme"));
                              if (!step.name || step.name === "Malzeme") step.name = safeName;
                              if (!step.Name || step.Name === "Malzeme") step.Name = safeName;
                              if (!step.productName) step.productName = safeName;
                          }
                      });
                      // v111.6: entry.recipe nesnesini targetRecipe ile senkronize et
                      entry.recipe = targetRecipe;
                  }
              });
          }
      }

      let orderModel = {
        id: cart.id,
        isNavigatedByQuestion: cart.isNavigatedByQuestion,
        customerId: cart.customer ? cart.customer.id : null,
        customerGiftId: cart.customerGiftId ? cart.customerGiftId : null,
        campaignGiftId: cart.campaignGiftId ? cart.campaignGiftId : null,
        totalPrice: cart.totalPrice,
        active: cart.active,
        cartEntries: [...cart.cartEntries],
        branchName: (this.$currentUser && this.$currentUser.branch) ? this.$currentUser.branch.name : (this.activePersonel && this.activePersonel.branch ? this.activePersonel.branch.name : "BrewMood"),
        paymentInformations: [...payments],
        userName: this.activePersonel ? (this.activePersonel.name + " " + (this.activePersonel.surname || "")) : "Kiosk",
        userId: this.activePersonel ? this.activePersonel.id : 0,
        discounts: this.discounts,
        note: this.note,
        customerName: this.customerName,
      };

      console.log("[OrderList] Sending orderModel for completion:", JSON.parse(JSON.stringify(orderModel)));
      console.log("[OrderList] EntryIds to be stamped:", orderModel.cartEntries.map(e => e.id));

      completePayment(orderModel)
        .then((result) => {
          if (result && (result === true || (result.data && result.data.isValid !== false))) {
            console.log("commit model çalıştı 2", result);
            const storeBillId = this.$store.getters["selfservice/getToLastBillId"];
            const finalOrderNo = storeBillId ? storeBillId : ((result.data && result.data.orderNo) ? result.data.orderNo : (result.data && result.data.id ? result.data.id : orderModel.id));
            console.log("[OrderList] Final Order No for Printer:", finalOrderNo);
            
            // 2. Snapshot Verilerini Yazıcıya Gönder
            if ((this.isPrintOrders || this.isKiosk) && this.$refs.printer2) {
              this.$refs.printer2.setOrderAndPrint({
                entries: cartItemsForPrint,
                totalPrice: snapshotTotalPrice,
                totalOriginPrice: snapshotTotalOriginPrice,
                totalDiscountPrice: snapshotTotalDiscountPrice,
                activePersonal: snapshotActivePersonal,
                billNo: finalOrderNo,
                currentDateTime: new Date().toLocaleString(),
                note: snapshotNote,
                customerName: snapshotCustomerName,
                isKiosk: this.isKiosk,
                // v117: Ödemeler ve bakiye bilgisini printer'a aktar (Hatalı hesaplamayı önlemek için)
                orderPayments: payments,
                leftPrice: 0 // Tamamlanan satışta bakiye sıfırdır
              }, this.printCopyCount, true, false, true);
            }

            // StaffActionLog for Order Conversion removed as per requirement (update existing logs)

            let totalEntryPrice = payments.reduce(
              (a, b) => a + (parseFloat(b.price) || 0),
              0
            );

            this.discounts = [];
            this.orderPayments = [];
            this.selectedCari = null;
            setTimeout(() => {
                this.isReset = true;
                this.isActive = false;
                this.note = "";
                this.customerName = "";
                this.tempNote = "";
                this.tempCustomerName = "";
            }, 1000);
            
            this.isCakeQuestioned = false;
            
            this.$store.dispatch("selfservice/setLastBillId");
            this.$vs.notify({
              color: "success",
              title: totalEntryPrice.toFixed(2) + " Tutarında Sepet Tamamlandı !",
              text: payments.length + " Ödeme Gerçekleşti.",
            });
          } else {
            this.discounts = [];
            this.$fire({
              title: "Hata !",
              text: "Ürün Satışı Tamamlanamadı !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Ürün Satışı Tamamlanamadı !",
            });
            // this.initValues();
            this.isTransaction = false;
          }
        })
        .catch((err) => {
          this.$fire({
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
          // this.initValues();,
          this.isTransaction = false;
        });
      this.discounts = [];
      this.isPieced = false;
    },
    seperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.paymentGroups
        );
        this.toggleCalc = true;
      }
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let branchId = userInfo.branch.id;
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posType = axiosResponse.data.posType;
    },
    checkPosConnection: async function () {
      if (!this.isPosEnabled) {
        this.isPosConnectionError = false;
        return;
      }
      let bridgeUrl = process.env.VUE_APP_POS_API;
      if (!bridgeUrl) {
        this.isPosConnectionError = true;
        return;
      }
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 1500);

      try {
        const response = await fetch(bridgeUrl, {
          method: "GET",
          signal: controller.signal,
          headers: {
            "Accept": "application/json"
          }
        });
        clearTimeout(timeoutId);
        this.isPosConnectionError = false;
      } catch (err) {
        clearTimeout(timeoutId);
        this.isPosConnectionError = true;
        console.warn("POS Bridge connection check failed:", err);
      }
    },
    startPosConnectionTimer() {
      this.stopPosConnectionTimer();
      this.checkPosConnection();
      this.posConnectionInterval = setInterval(() => {
        this.checkPosConnection();
      }, 5000);
    },
    stopPosConnectionTimer() {
      if (this.posConnectionInterval) {
        clearInterval(this.posConnectionInterval);
        this.posConnectionInterval = null;
      }
    },
    setIsPieced: function () {
      this.isPieced = true;
    },
    doPayWithoutPos: function (payedPrice, isDiscount) {
      if (this.isKiosk && (!this.customerName || this.customerName.trim() === "")) {
        this.$fire({
          title: "Eksik Bilgi",
          text: "Siparişe devam etmek için lütfen adınızı giriniz.",
          type: "warning",
        });
        return;
      }
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true;
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && !this.selectedCari && !isDiscount) {
        this.$refs.cariSelect.openPopup();
        this.$nextTick(() => {
          this.isTransaction = false;
        });
        return;
      }
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID) {
        this.openQrReader(payedPrice, isDiscount);
        return;
      }
      this.finalizePaymentInternal(payedPrice, isDiscount);
    },
    doPay: async function (payedPrice, isDiscount) {
      if (this.isKiosk && (!this.customerName || this.customerName.trim() === "")) {
        this.$fire({
          title: "Eksik Bilgi",
          text: "Siparişe devam etmek için lütfen adınızı giriniz.",
          type: "warning",
        });
        return;
      }
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true;
      this.isPaymentStarted = true;
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && !this.selectedCari && !isDiscount) {
        this.$refs.cariSelect.openPopup();
        this.$nextTick(() => {
          this.isTransaction = false;
          this.isPaymentStarted = false;
        });
        return;
      }

      if (this.isPosConnectionError && !isDiscount && this.selectedPaymentMethod && 
          (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
        this.$vs.notify({
          color: "danger",
          title: "Bağlantı Hatası",
          text: "POS Bridge bağlantısı olmadığı için ödeme yapılamaz!",
        });
        this.isTransaction = false;
        this.isPaymentStarted = false;
        return;
      }
      if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) { // Keep original env name if that's what's used
        this.doPayGmp(payedPrice, isDiscount);
        return;
      }

      let posSaleItems = [];
      let currentSelectedGroups = this.selectedPaymentGroup.length > 0 ? this.selectedPaymentGroup : this.paymentGroups;
      
      // Toplam seçili tutarı (kalan borçlar toplamı) hesapla
      const totalRemainingOfSelected = currentSelectedGroups.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      let distributedAcrossGroups = 0;
      const targetPayedPrice = parseFloat(payedPrice);

      currentSelectedGroups.forEach((selectProduct, gIdx) => {
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          // Bu ürüne düşen ödeme payını hesapla (Oransal Dağıtım)
          let ratio = totalRemainingOfSelected > 0 ? ((selectProduct.totalPrice - selectProduct.payedPrice) / totalRemainingOfSelected) : 0;
          let groupTargetPrice = (gIdx === currentSelectedGroups.length - 1)
            ? (targetPayedPrice - distributedAcrossGroups)
            : (targetPayedPrice * ratio);
          
          groupTargetPrice = Math.round(groupTargetPrice * 100) / 100;
          distributedAcrossGroups += groupTargetPrice;

          if (groupTargetPrice > 0) {
            if (selectProduct.entries.length == 1) {
              let saleModel = {
                id: selectProduct.entries[0].productId || selectProduct.entries[0].id || 0,
                name: selectProduct.entries[0].productName,
                quantity: selectProduct.entries[0].productQuantity || selectProduct.entries[0].quantity || 1,
                kdv: selectProduct.entries[0].kdv,
                price: groupTargetPrice, // Artık kalan borcu değil, oransal payı yolluyoruz
              };
              posSaleItems.push(saleModel);
            } else {
              let groupDistributed = 0;
              selectProduct.entries.forEach((entry, eIdx) => {
                let eRatio = selectProduct.totalPrice > 0 ? (entry.price / selectProduct.totalPrice) : 0;
                let eChunk = (eIdx === selectProduct.entries.length - 1)
                  ? Math.round((groupTargetPrice - groupDistributed) * 100) / 100
                  : Math.round((groupTargetPrice * eRatio) * 100) / 100;

                let saleModel = {
                  id: entry.productId || entry.id || 0,
                  name: entry.productName,
                  quantity: entry.productQuantity || entry.quantity || 1,
                  kdv: entry.kdv,
                  price: Math.round(eChunk * 1000) / 1000,
                };
                posSaleItems.push(saleModel);
                groupDistributed += eChunk;
              });
            }
          }
        }
      });

      // Eğer kalem seçili değilse tüm sepeti baz al (Masa sistemindeki gibi)
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
      } else {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
      }

      const isPosPayment = !isDiscount && (this.selectedPaymentMethod.id == process.env.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID);

      if (this.isPosEnabled && isPosPayment) {
        this.isLoading = true;
        let data = null;
        let fetchFailed = false;

        try {
          const response = await fetch(process.env.VUE_APP_POS_API + "complete-sale", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
              SaleItems: posSaleItems,
            }),
          });

          if (!response.ok) {
            throw new Error(`Sunucu Hatası: ${response.status}`);
          }
          
          data = await response.json();
        } catch (err) {
          fetchFailed = true;
          console.error("POS Köprü Hatası (Catch):", err);
          this.isLoading = false;
          this.isPaymentStarted = false;
          this.isTransaction = false;
          
          this.$vs.notify({
            color: "danger",
            title: "POS Hatası",
            text: "POS cihazından yanıt alınamadı. Ödeme işlemi gerçekleştirilemedi!",
          });
          return;
        }

        // JS Hatalarının ağ hatası gibi algılanmaması için (catch bloğuna düşmemesi için)
        // Başarılı senaryoyu try/catch bloğunun dışına alıyoruz.
        if (!fetchFailed && data) {
            this.isLoading = false;
            let isStrictSuccess = false;
            let resultData = data.data || data;

            const successStatuses = [3, 4, 5, 6, 8, 9, 10, 18, 19, 20, 21, 22, 24];
            if (resultData && successStatuses.includes(resultData.statusId)) {
                isStrictSuccess = true;
            }

            if (isStrictSuccess) {
              this.finalizePaymentInternal(payedPrice, isDiscount, resultData);
            } else {
              this.isPaymentStarted = false;
              this.isTransaction = false;
              this.$fire({
                title: "İptal",
                text: data.message || "Ödeme POS cihazından iptal edildi veya başarısız oldu.",
                type: "error",
              });
            }
        }
      } else {
        this.finalizePaymentInternal(payedPrice, isDiscount);
      }
    },
    finalizePaymentInternal(payedPrice, isDiscount, posData = null) {
      const payedPriceFloat = parseFloat(payedPrice) || 0;

      // Eğer kalem seçili değilse tüm sepeti baz al
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
      }

      // --- ORANTILI DAĞITIM ---
      const totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      let distributedAmount = 0;

      this.selectedPaymentGroup.forEach((group, index) => {
        const remaining = group.totalPrice - group.payedPrice;
        const pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
        
        let chunk = 0;
        if (index === this.selectedPaymentGroup.length - 1) {
          chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
        } else {
          chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
        }
        
        group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
        if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
        distributedAmount += chunk;

        if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
          group.status = "Ödendi";
        }
      });

      // Değişiklikleri ana listeye işle
      this.selectedPaymentGroup.forEach((modifiedGroup) => {
         let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
         if (idx !== -1) {
           this.$set(this.paymentGroups, idx, modifiedGroup);
         }
      });

      this.reCalculatePaymentGroup();

      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: isDiscount ? (this.paymentMethods.find(x => x.id == 4) || _.cloneDeep(this.selectedPaymentMethod)) : _.cloneDeep(this.selectedPaymentMethod),
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
        discountDescription: isDiscount ? this.paymentDiscount.discountDescription : null,
      };
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && this.selectedCari) {
        orderPayment.cariId = this.selectedCari.id;
        orderPayment.cariName = this.selectedCari.name;
      }

      if (posData) {
        let posStatusId = this.getPaymentMethodIdFromPosResponse(posData, this.selectedPaymentMethod.id);
        orderPayment.paymentMethod.id = posStatusId;
        if (posData.financialDocuments && posData.financialDocuments.length > 0) {
          orderPayment.financialDocument = posData.financialDocuments[0];
          orderPayment.financialDocument.saleUid = posData.saleUid;
          orderPayment.financialDocument.orderNo = posData.orderNo;
        }
      }

      this.orderPayments.push(orderPayment);
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice([]);
      this.selectedPaymentGroup = [];
      this.toggleCalc = false;
      this.isPaymentStarted = false;
      this.isTransaction = false;

      this.$vs.notify({
        color: "success",
        title: "Başarılı",
        text: payedPrice + " TL Değerinde Ödeme Gerçekleşti.",
      });
    },
    getPaymentMethodIdFromPosResponse(resultData, defaultId) {
      let posStatusId = defaultId;
      if (resultData && resultData.addedPayments && Array.isArray(resultData.addedPayments)) {
        let successfulPayments = resultData.addedPayments.filter(p => p.statusId === 2);
        if (successfulPayments.length > 0) {
          let addedPayment = successfulPayments[successfulPayments.length - 1];
          let paymentTypeId = addedPayment.paymentTypeId;
          let mediatorId = addedPayment.paymentMediatorId;
          
          if (paymentTypeId) {
            posStatusId = paymentTypeId;
          }
          
          if (addedPayment.isExternal) {
            let targetMethodName = "";
            
            // Standard PAVO Mediator ID / PaymentType ID mappings for External Payments:
            // 1/101 = Multinet
            // 2/102 = Sodexo
            // 3/103/13/26/113/126 = Ticket (Edenred / Ticket Gift)
            // 4/104 = Setcard
            // 5/105 = Metropol
            // 6/106 = TokenFlex
            if (mediatorId === 1 || mediatorId === 101 || paymentTypeId === 1 || paymentTypeId === 101) {
              targetMethodName = "Multinet";
            } else if (mediatorId === 2 || mediatorId === 102 || paymentTypeId === 2 || paymentTypeId === 102) {
              targetMethodName = "Sodexo";
            } else if (
              mediatorId === 3 || mediatorId === 103 || mediatorId === 13 || mediatorId === 26 || mediatorId === 113 || mediatorId === 126 ||
              paymentTypeId === 3 || paymentTypeId === 103 || paymentTypeId === 13 || paymentTypeId === 26 || paymentTypeId === 113 || paymentTypeId === 126
            ) {
              targetMethodName = "Ticket";
            } else if (mediatorId === 4 || mediatorId === 104 || paymentTypeId === 4 || paymentTypeId === 104) {
              targetMethodName = "Setcard";
            } else if (mediatorId === 5 || mediatorId === 105 || paymentTypeId === 5 || paymentTypeId === 105) {
              targetMethodName = "Metropol";
            } else if (mediatorId === 6 || mediatorId === 106 || paymentTypeId === 6 || paymentTypeId === 106) {
              targetMethodName = "TokenFlex";
            }
            
            if (targetMethodName) {
              let matchingMethod = this.paymentMethods.find(m => 
                (m.Name && m.Name.toLowerCase().includes(targetMethodName.toLowerCase())) ||
                (m.name && m.name.toLowerCase().includes(targetMethodName.toLowerCase()))
              );
              if (matchingMethod) {
                posStatusId = matchingMethod.id;
              }
            }
          }
        }
      }
      return posStatusId;
    },
    reCalculatePaymentGroup: function () {
      this.paymentGroups.forEach((pgroup) => {
        let totalPrice = 0;

        pgroup.entries.forEach((entry) => {
          totalPrice += Math.round(entry.price * 100) / 100;
        });
        pgroup.totalPrice = Math.round(totalPrice * 100) / 100;
      });
    },
    doPayGmp: function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true;
      this.isPaymentStarted = true;

      if (this.isPosConnectionError && !isDiscount && this.selectedPaymentMethod && 
          (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
        this.$vs.notify({
          color: "danger",
          title: "Bağlantı Hatası",
          text: "POS Bridge bağlantısı olmadığı için ödeme yapılamaz!",
        });
        this.isTransaction = false;
        this.isPaymentStarted = false;
        return;
      }
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
      } else {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
      }

      let posSaleItems = [];
      let saleDto = {
        name: "İçecek",
        price: Math.round(payedPrice * 1000) / 1000,
        quantity: 1,
        kdv: this.selectedPaymentGroup[0].entries[0].kdv,
      };
      posSaleItems.push(saleDto);
      
      this.isLoading = true;

      fetch(process.env.VUE_APP_POS_API + "create", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
            SaleItems: posSaleItems,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Local Bridge Error (500)");
            }
            return response.json();
          })
          .then((data) => {
            this.isLoading = false;
            if (data.statusCode == 200) {
              this.finalizePaymentInternal(payedPrice, isDiscount, data);
            } else {
              this.isPaymentStarted = false;
              this.isTransaction = false;
              this.$fire({
                title: data.message,
                text: "",
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.error("POS GMP Köprü Hatası (Catch):", err);
            this.isLoading = false;
            this.isPaymentStarted = false;
            this.isTransaction = false;
            
            this.$vs.notify({
              color: "danger",
              title: "POS Bağlantı Hatası (GMP)",
              text: "Lokal servis yanıt vermedi. İşlem durumunu kontrol ediniz.",
            });
          });
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          selectedPrice += parseFloat(entry.originPrice) || parseFloat(entry.price) || 0;
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },
    commitPay(payedPrice, isDiscount) {
      console.log("tamamlandı commit");
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      if (this.cloneCurrentCart.customer) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach((x) => {
          x.categoryId = x.categories[0].id;
        });
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan",
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some((s) => s.rowIndex == item.rowIndex)) {
          console.log(item);
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice =
            Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some((rm) => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
        this.selectedPaymentGroup
      );
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();
      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
      };
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && this.selectedCari) {
        orderPayment.cariId = this.selectedCari.id;
        orderPayment.cariName = this.selectedCari.name;
      }
      this.orderPayments.push(orderPayment);
      this.toggleCalc = false;
      this.$vs.notify({
        color: "success",
        title: "Tebrikler",
        text: payedPrice + " TL Değerinde Ödeme Gerçekleşti.",
      });
    },
    handleCariSelected(cari) {
      this.selectedCari = cari;
      if (this.isPosEnabled) {
        this.doPay(
          this.selectedPaymentGroup.length > 0 ? this.selectedGroupsPrice : this.totalPrice,
          false
        );
      } else {
        this.doPayWithoutPos(
          this.selectedPaymentGroup.length > 0 ? this.selectedGroupsPrice : this.totalPrice,
          false
        );
      }
    },
    openQrReader(amount, isDiscount) {
      this.$refs.qrReader.isActive = true;
      this.$refs.qrReader.isWallet = true;
      this.$refs.qrReader.amount = amount.toFixed(2);
      this.$refs.qrReader.isDiscount = isDiscount;
    },
    calculateSelectedRemainingPrice: function (selectedGroups) {
      if (!selectedGroups || !Array.isArray(selectedGroups)) return 0;
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        if (item) selectedPrice += (item.totalPrice || 0) - (item.payedPrice || 0);
      });
      return selectedPrice;
    },
    closeCalculatorPage() {
      this.isCalculatorPageActive = false;
    },
    handlePopupUpdate(newValue) {
      // Pop-up kapanmak istediğinde: sadece POS işlemi aktifken (kart/cüzdan bekleniyor) engelle
      // Normal "Geri Dön" tıklaması veya rastgele tıklamalar engellenmemeli
      if (!newValue && this.isPaymentStarted && !this.isKiosk) {
        this.$nextTick(() => {
          this.isActive = true;
        });
      } else if (!newValue) {
        // Kiosk veya isPaymentStarted=false ise serbest bırak, state'i temizle
        this.isPaymentStarted = false;
        this.isTransaction = false;
      }
    },
  },
  created() {
    this.checkPosDevice();
    this.isPaymentStarted = false;
    const savedPrintPreference = localStorage.getItem("selfservice2_isPrintOrders");
    if (savedPrintPreference !== null) {
      this.isPrintOrders = savedPrintPreference === "true";
    }
    const savedCopyCount = localStorage.getItem("selfservice2_printCopyCount");
    if (savedCopyCount !== null) {
      this.printCopyCount = parseInt(savedCopyCount) || 1;
    }
    // Restore Kiosk Note and Name
    const savedKioskNote = localStorage.getItem("kiosk_note");
    if (savedKioskNote !== null) {
      this.note = savedKioskNote;
    }
    const savedKioskName = localStorage.getItem("kiosk_customerName");
    if (savedKioskName !== null) {
      this.customerName = savedKioskName;
    }
  },
  beforeDestroy() {
    this.stopPosConnectionTimer();
  },
};
</script>

<style>
.payment-log {
  border-bottom: 0.1rem solid black;
}

/* Kiosk Not/Ad Info Row */
.kiosk-info-row {
  min-height: 48px;
  align-items: center;
}

.kiosk-delete-btn {
  flex-shrink: 0;
  min-width: 64px !important;
  height: 36px !important;
  font-size: 0.95rem !important;
  font-weight: 700 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Kiosk Not/Ad Info Row (Gray Version) */
.kiosk-info-row-gray {
  min-height: 54px;
  background-color: #f1f3f5 !important;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  margin-top: 2px;
}

.kiosk-gray-icon {
  color: #495057;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.kiosk-gray-label {
  color: #495057;
  font-weight: 700;
  font-style: italic;
  font-size: 1.1rem;
  white-space: nowrap;
}

.kiosk-gray-value {
  color: #212529;
  font-weight: 600;
  font-size: 1.15rem;
  word-break: break-word;
}

#orderListTable.has-note .vs-table--content {
  height: calc(100vh - 465px) !important;
}

#orderListTable.has-name .vs-table--content {
  height: calc(100vh - 465px) !important;
}

#orderListTable.has-note.has-name .vs-table--content {
  height: calc(100vh - 535px) !important;
}

/* Kiosk Specific Table Heights - Daha fazla alan bırakmak için */
#orderListTable.kiosk-table .vs-table--content {
  height: calc(100vh - 485px) !important;
}

#orderListTable.kiosk-table.has-note .vs-table--content {
  height: calc(100vh - 555px) !important;
}

#orderListTable.kiosk-table.has-name .vs-table--content {
  height: calc(100vh - 555px) !important;
}

#orderListTable.kiosk-table.has-note.has-name .vs-table--content {
  height: calc(100vh - 625px) !important;
}

.payment-history::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.payment-history {
  border: 0.1rem solid black;
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-radius: 1rem;
  background: #ffd1d1;
  overflow: auto;
  max-height: 185px;
}

#orderListTable .vs-table--content {
  height: calc(100vh - 395px);
}

.calc-button .includeIconOnly {
  width: unset !important;
  height: unset !important;
}

.calc-button {
  padding: 1rem 0.5rem !important;
  width: fit-content;
  display: flex;
}

.calc-button .large-icon i {
  font-size: 2.5rem !important;
  color: var(--vs-primary);
}

.calc-button .small-icon i {
  font-size: 1.5rem !important;
}

.info-row {
  padding: 0.75rem 0.75rem !important;
  border-top: 1px solid;
  background: #f9f5f5 !important;
  font-size: 1.1rem !important;
  padding-bottom: 0 !important;
}

#orderList .vs-popup .vs-popup--content {
  height: 97vh !important;
  max-height: 100vh !important;
  overflow: hidden;
}

#orderList .vs-popup .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

#orderList .vs-popup {
  border-radius: 2rem !important;
}

#orderList .vs-popup .vs-popup--header {
  display: none;
}

.payment-label {
  font-size: 1.25rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

.payment-label i {
  font-size: 3rem !important;
  margin-right: 2rem !important;
}

#orderList .vs-table--tbody-table tr {
  background: none;
}

#orderList .giftsOpenerButton {
  z-index: 600;
}

#orderListTable .vs-table--content .vs-con-tbody .vs-table .vs-table--thead {
  background: #ffd1d1;
}

#orderListTable
  .con-tablex
  .vs-con-tbody
  .vs-table
  .vs-table--thead
  tr
  th
  .vs-table-text {
  border: none !important;
}

#orderListTable .vs-con-tbody .vs-table .vs-table--thead tr th {
  padding-bottom: 0 !important;
}

#orderListTable .vs-table--thead th:nth-child(1) .vs-table-text {
  justify-content: flex-start !important;
  text-align: left !important;
  margin: 0 !important;
  padding: 0 !important;
}

#orderListTable .vs-table--thead th:not(:nth-child(1)) .vs-table-text {
  justify-content: center !important;
  text-align: center !important;
}

.column-head-text {
  font-size: 1.1rem !important;
  color: #543633 !important;
}

.tr-text {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.tr-text-child {
  font-size: 1rem !important;
  font-weight: 600;
  font-style: italic;
}

.vs-table-primary .is-selected {
  background: #b8eeb8 !important;
}

.price-label {
  font-size: 1.1rem !important;
  color: #543633 !important;
  font-weight: 600 !important;
}

.price {
  font-size: 1.75rem !important;
  color: #543633 !important;
  line-height: 1.75rem !important;
}

.line-through {
  text-decoration: line-through !important;
}
.payed-row {
  color: rgb(130, 223, 130) !important;
  text-shadow: 0px 0px 3px rgb(226, 226, 226);
}
.swal2-container {
  z-index: 100001;
}

/* Merge Product Modal Styles */
#mergeProductModal .vs-popup .vs-popup--header {
  display: none !important;
}

#mergeProductModal .vs-popup .vs-popup--content {
  padding: 1.5rem !important;
  max-width: 550px !important;
  width: 90vw !important;
  max-height: 85vh !important;
}

#mergeProductModal .vs-popup {
  border-radius: 1rem !important;
}

.price-input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem !important;
  border: 1px solid #e1e1e1 !important;
  border-radius: 0.5rem !important;
}

/* Responsive Footer Styles */
.res-footer-row {
  flex-wrap: wrap !important;
  min-height: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.res-footer-col {
  padding: 5px 0;
}

@media (max-width: 768px) {
  .res-footer-row {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .res-order-2 { order: 2; }
  .res-order-3 { order: 3; }
  .res-order-4 { order: 4; }
  
  .res-footer-row .price-label {
    font-size: 0.9rem !important;
    margin-right: 5px !important;
  }
  .res-footer-row .price {
    font-size: 1.25rem !important;
  }
  .res-footer-row .vs-checkbox {
    font-size: 0.85rem !important;
  }
}

/* Kiosk Premium Overrides */
.payment-label {
  height: 60px !important;
  font-size: 1.5rem !important;
  letter-spacing: 2px;
  text-transform: uppercase;
  border-radius: 0 !important;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
}

#orderListTable .con-tablex {
  border: none !important;
  box-shadow: none !important;
  max-height: none !important;
  overflow: auto;
  
  .vs-table--thead th {
    background: #f8f8f8;
    padding: 15px 15px !important;
    
    .column-head-text {
      font-size: 1.15rem !important;
      font-weight: 700;
      color: #333 !important;
      text-align: left !important;
    }
  }

  .vs-tr {
    height: 70px !important;
    border-bottom: 1px solid #f0f0f0;

    .tr-text {
      font-size: 1.25rem !important;
      color: #2c3e50 !important;
    }
    
    .tr-text-child {
      font-size: 1rem !important;
      color: #7f8c8d !important;
    }
  }
}

.res-footer-row {
  height: 75px !important;
  display: flex !important;
  align-items: center !important;
  background: #fff5f5 !important;
  border-top: 2px solid #ffeded;
  
  .price-label {
    font-size: 1.3rem !important;
  }
  
  .price {
    font-size: 2rem !important;
    color: #e74c3c !important;
  }
}

.kiosk-btn-large {
  min-width: 250px !important;
  height: 65px !important;
  font-size: 1.4rem !important;
  border-radius: 35px !important;
  margin: 5px !important;
  font-weight: 700 !important;
  letter-spacing: 1px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1) !important;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.95) translateY(2px);
  }
}

.bg-success-gradient {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%) !important;
}

.bg-primary-gradient {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
}

#orderList {
  .vs-popup {
    background: #fff !important;
  }
}

.kiosk-popup-no-close .vs-popup--close {
  display: none !important;
}
</style>
